import { Component } from '@angular/core';

@Component({
  selector: 'app-cancellation-refund',
  imports: [],
  templateUrl: './cancellation-refund.component.html',
  styleUrl: './cancellation-refund.component.css'
})
export class CancellationRefundComponent {

}
